import { AnimatePresence, motion } from "framer-motion";
import { useContext, useEffect, useState } from "react";
import { APIENDPOINT } from "../services/apiHelper";
import toast from "react-hot-toast";
import { FORMNAMES } from "../utilities/codes";
import { getFormEntriesByFormName } from "../services/formServices";
import { schoolContext } from "../contexts/SchoolContextProvider";
import { mediaSource, useBackgroundImage } from "../utilities/mediautilities"
import { useTranslation } from "react-i18next"
import { I18N_KEYS } from "../languages/PlaceHolder.js";

const Infrastructure = () => {
    const [selectedCard, setSelectedCard] = useState(null);
    const [infrastructure, setInfrastructure] = useState([]);
    const { schoolDetails } = useContext(schoolContext);
    const { t } = useTranslation()
    const bgUrl = useBackgroundImage(schoolDetails?.inf_background_image?.fileUrl);

    useEffect(() => {
        getInfrastructure();
    }, [])

    const getInfrastructure = async () => {
        try {
            const response = await getFormEntriesByFormName(FORMNAMES.SCHOOLINFRASTUCTURE);
            setInfrastructure(response);
        } catch (error) {
            toast.error(error.message);
        }
    }

    return (
        <>
            {(infrastructure && infrastructure?.length > 0) &&
                <>
                    <section className="relative py-24 bg-fixed" style={{ backgroundImage: `url(${bgUrl})` }}>
                        <div className="absolute inset-0 bg-black/80" />
                        <div className="relative z-10 common-container">
                            <h2 className="text-4xl text-accent font-bold text-center">
                                {t(I18N_KEYS.INFRASTRUCTURETITLE)}
                            </h2>
                            <p className="text-accent mt-2 text-center mb-10">{schoolDetails?.inf_subtitle && schoolDetails?.inf_subtitle}</p>

                            <div className="grid md:grid-cols-3 gap-8">
                                {infrastructure?.map((infs, i) => (
                                    <motion.div
                                        key={i}
                                        initial={{ opacity: 0, y: 40 }}
                                        whileInView={{ opacity: 1, y: 0 }}
                                        transition={{ type: "tween", duration: 0.5 }}
                                        whileHover={{ scale: 1.08, y: -10 }}
                                        onClick={() => setSelectedCard(infs)}
                                        className="backdrop-blur-xl bg-accent/10 border border-accent/20 rounded-2xl overflow-hidden shadow-xl cursor-pointer"
                                    >
                                        <img
                                            src={mediaSource(infs?.payload?.inf_image?.fileUrl)}
                                            className="h-44 w-full object-cover"
                                            onError={(e) => mediaSource(e)}
                                        />
                                        <div className="p-5 text-accent">
                                            {infs?.payload?.ar_name &&
                                                <h4 className="text-lg font-semibold">{infs?.payload?.ar_name}</h4>
                                            }
                                            {infs?.payload?.inf_description &&
                                                <p className="text-sm opacity-80"
                                                    dangerouslySetInnerHTML={{
                                                        __html: infs?.payload?.inf_description
                                                    }}
                                                ></p>
                                            }
                                        </div>
                                    </motion.div>
                                ))}
                            </div>
                        </div>
                    </section>
                    <AnimatePresence>
                        {selectedCard && (
                            <motion.div
                                className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                onClick={() => setSelectedCard(null)}
                            >

                                <button
                                    onClick={() => setSelectedCard(null)}
                                    className="absolute top-4 right-4 text-accent text-3xl font-bold hover:text-primary"
                                >
                                    &times;
                                </button>
                                <motion.div
                                    className="bg-accent rounded-2xl overflow-hidden shadow-2xl max-w-3xl w-full"
                                    initial={{ scale: 0.8, y: 40 }}
                                    animate={{ scale: 1, y: 0 }}
                                    exit={{ scale: 0.8, y: 40 }}
                                    transition={{ duration: 0.3 }}
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <img
                                        src={mediaSource(selectedCard?.payload?.inf_image?.fileUrl)}
                                        alt={selectedCard?.payload?.ar_name}
                                        onError={(e) => mediaSource(e)}
                                        className="w-full h-full object-cover"
                                    />
                                    {(selectedCard?.payload?.ar_name || selectedCard?.payload?.inf_description) &&
                                        <div className="p-6">
                                            {selectedCard?.payload?.ar_name &&
                                                <h3 className="text-2xl font-bold mb-2">
                                                    {selectedCard?.payload?.ar_name}
                                                </h3>
                                            }
                                            {selectedCard?.payload?.inf_description &&
                                                <p className="text-gray-600"
                                                    dangerouslySetInnerHTML={{
                                                        __html: selectedCard?.payload?.inf_description
                                                    }}
                                                >
                                                </p>
                                            }
                                        </div>
                                    }

                                </motion.div>
                            </motion.div>
                        )}
                    </AnimatePresence>
                </>

            }
        </>
    )
}

export default Infrastructure;